<template>
    <div class="search-list" :class="msp.isListView ? 'search-result-table' : 'search-result-grid'">
        <div>

            <div class="search-header-stick">
                <searchTitle />
                <div v-if="currentDpp" class="search-header-detail inline bg-default">
                    <div class="search-header-detail-panel">
                        <div class="search-header-detail-img">
                            <span class="tag small default active" v-if="currentDpp.photoCount">{{currentDppPhotoIndex+1}}/{{currentDpp.photoCount}}</span>
                            <img @click="openPhotoLink"  v-if="currentDpp.tnImgPath" :src="currentDppPhoto" >
                            <button v-if="currentDppPhotoIndex > 0" type="button" class="search-header-detail-img-arrow prev" @click="prevPhoto"> <i class="icon-angle-left circle default small f3"></i></button>
                            <button v-if="currentDppPhotoIndex < Math.max(0, currentDpp.photoCount - 1) " type="button" class="search-header-detail-img-arrow next" @click="nextPhoto"> <i class="icon-angle-right circle default small f3"></i></button>
                        </div>
                        <div class="flex vertical">
                            <div>
                                <div class="flex small left middle">
                                    <div v-if="currentDpp.price">
                                        <b class="f3 text-bold">{{$filters.formatPrice(currentDpp.price)}}</b><a v-if="currentDpp.isEstPrice" :href="currentDpp.dppUrl+'#propertyEstimatePanel'" class="f6"> Est</a>
                                    </div>
                                    <div  v-if="!currentDpp.isRentals && currentDpp.pricePerArea">
                                        <span class="f7 text-gray">{{$filters.formatPricePerArea(currentDpp.pricePerArea, currentDpp.isLand)}}/{{currentDpp.areaUnit}}</span>
                                    </div>
                                    <div class="search-header-detail-btn flex right">
                                        <a :href="currentDpp.dppUrl" target="_blank" class="btn primary small">See Full Details</a>
                                        <button type="button" @click.stop="favoriteAction(currentDpp)" class="favorite circle bg-default small" title="Save"><i class="icon-heart-o" :class="{'active':isFavorite}"></i></button>
                                    </div>
                                </div>
                                <div class="flex small nowrap left">
                                    <div v-if="currentDpp.bed">
                                        <b class="text-bold"> {{currentDpp.bed || '—'}}</b>
                                        <span class="f7">Bd</span>
                                    </div>
                                    <div v-if="currentDpp.bath">
                                        <b class="text-bold"> {{currentDpp.bath || '—'}}</b>
                                        <span class="f7">Ba</span>
                                    </div>
                                    <div v-if="currentDpp.area">
                                        <b class="text-bold">{{$filters.formatArea(currentDpp.area, currentDpp.isLand)}}</b>
                                        <span class="f7">{{currentDpp.areaUnit}}</span>
                                    </div>
                                    <div v-if="currentDpp.lotSize">
                                        <b class="text-bold">{{$filters.formatArea(currentDpp.lotSize , currentDpp.isLand)}} </b>
                                        <span class="f7">{{currentDpp.areaUnit}} Lot</span>
                                    </div>
                                </div>
                                <div class="f7" v-if="currentDpp.geo">
                                    <span>{{currentDpp.geo.address}}</span>, <span>{{currentDpp.geo.city}}</span>, <span>{{currentDpp.geo.state}}</span>
                                </div>
                            </div>
                            <div class="f7 addtional" v-if="currentDppDetail">
                                <div class="grid xs-grid-cols-4">
                                    <div v-if=" currentDppDetail.estPriceInfo && currentDppDetail.estPriceInfo.estPrice">
                                        <div>Estimate</div>
                                        <div class="text-bold"><a target="_blank" class="link" :href="currentDpp.dppUrl+'#propertyEstimatePanel'">{{$filters.formatFriendlyPrice(currentDppDetail.estPriceInfo.estPrice)}}</a></div>
                                    </div>
                                    <div v-if=" currentDppDetail.monthlyInfo && currentDppDetail.monthlyInfo.loanPerMonth">
                                        <div>Mortgage</div>
                                        <div class="text-bold"><a target="_blank" class="link" :href="currentDpp.dppUrl+'#propertyMortgagePanel'">{{$filters.formatFriendlyPrice(currentDppDetail.monthlyInfo.loanPerMonth)}}</a></div>
                                    </div>
                                    <div v-if="currentDppDetail.nearbySchoolAvgRating">
                                        <div>Schools</div>
                                        <div class="text-bold">
                                            <a target="_blank" class="link" :href="currentDpp.dppUrl+'?school=1'">{{`${currentDppDetail.nearbySchoolAvgRating.min}/10 - ${currentDppDetail.nearbySchoolAvgRating.max}/10`}}</a>
                                        </div>
                                    </div>
                                    <div v-if="currentDpp.yearBuilt">
                                        <div>Year Built</div>
                                        <div class="text-bold"><a target="_blank" class="link" :href="currentDpp.dppUrl+'#propertyDetailPanel'">{{currentDpp.yearBuilt}}</a></div>
                                    </div>
                                </div>
                                <div class="multipleline-2 m-t-1 f7" style="position: relative;">{{currentDppDetail.description ? currentDppDetail.description.slice(0,100) + '...' : ''}} <a class="link"  :href="currentDpp.dppUrl + '#propertyDescriptionPanel'" target="_blank">See more</a></div>
                            </div>
                            <div v-else class="skeleton addtional">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="search-table">
                    <table class="table f7">
                        <thead>
                            <tr>
                                <th class="col-property-img"></th>
                                <th class="col-property-type"></th>
                                <th class="col-property-price"><button type="button" :class="sortByPrice? 'link': ''" @click="toggleSort('price')">Price <i class="f7" :class="sortByPrice"></i></button></th>
                                <th class="col-property-pricepersqft"><button type="button" :class="sortByPricePerSqft? 'link': ''" @click="toggleSort('pricepersqft')">$/Sqft <i class="f7" :class="sortByPricePerSqft"></i></button></th>
                                <th class="col-property-bed"><button type="button" :class="sortByBed? 'link': ''" @click="toggleSort('beds')">Bd <i class="f7" :class="sortByBed"></i></button></th>
                                <th class="col-property-bath"><button type="button" :class="sortByBath? 'link': ''" @click="toggleSort('baths')">Ba <i class="f7" :class="sortByBath"></i></button></th>
                                <th class="col-property-sqft"><button type="button" :class="sortBySqft? 'link': ''" @click="toggleSort('sqft')">Sqft <i class="f7" :class="sortBySqft"></i></button></th>
                                <th class="col-property-lotsize"><button type="button" :class="sortByLot? 'link': ''" @click="toggleSort('lot')">Lot <span class="hidden-xs">Size</span> <i class="f7" :class="sortByLot"></i></button></th>
                                <th class="col-property-dom"><button type="button" :class="sortByUpdated? 'link': ''" @click="toggleSort('updated')">On Movoto <i class="f7" :class="sortByUpdated"></i></button></th>
                                <th class="col-property-fav">&nbsp;</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
             <template  v-if="getListings && getListings.length" >
                 <div v-if="!msp.isListView" class="search-grid" comp="searchGrid"
                 >
                     <template v-for="(house,i) in getListings">
                        <mvtCardProperty
                            v-if="house && house.propertyId"
                            :showSchema="true"
                            :data="house"
                            :preload="glb.isPhone ?  i < 4 : i <9"
                            @selectItem="sendSelectItem"
                            :key="house && house.propertyId"
                            @mouseenter="() => onPropertyMouseEnter(house.propertyId)"
                            @mouseleave="onPropertyMouseLeave"
                        ></mvtCardProperty>
                     </template>
                     <searchAds class="rentalAd" v-if="glb.rentals" :data="getRentalAdData"></searchAds>
                     <template v-for="i in adsCount" :key="i">
                         <div :order="i-1">
                             <mvtAds v-if="i <= adsCount" :options="{type:'search', index: i-1}" :key="mvtAdsKey + i"></mvtAds>
                             <searchAds v-else :type="i-1" :index="i-1"></searchAds>
                         </div>
                     </template>
                     <div order="ads" v-if="msp.displayPageIndex==1 && !msp.filter.rentals" >
                        <searchAdsAgentConnection ></searchAdsAgentConnection>
                     </div>
                 </div>
                 <div v-else class="search-table " comp="searchTable">
                     <table class="table">
                         <tbody class="f7">
                            <template v-for="(item,i) in getListings" :key="'tablekey'+i">
                                <tr
                                    :class="{selected: i === index}"
                                    @click.stop="selectIndex(i)"
                                    :mark-id="'mark0_' + item.geo.lat + '_' + item.geo.lng"
                                    @mouseenter="() => onPropertyMouseEnter(item.propertyId)"
                                    @mouseleave="onPropertyMouseLeave"
                                >
                                    <td class="col-property-img">
                                        <img loading="lazy" :src="item.tnImgPath" />
                                    </td>
                                    <td class="col-property-type" :title="item.propertyTypeName">
                                         <i :class="item.propertyTypeIcon" class="f4 text-front"></i>
                                     </td>
                                     <td class="col-property-price">
                                         <span>{{$filters.formatPrice(item.price)}}</span>
                                     </td>
                                     <td class="col-property-pricepersqft">
                                        <span v-if="!item.isLand">
                                            {{$filters.formatPrice(item.pricePerArea)}}
                                        </span>
                                        <span v-else>—</span>
                                    </td>
                                     <td class="col-property-bed">
                                         <span v-if="item.bed">
                                             {{ item.bed}}
                                         </span>
                                         <span v-else>—</span>
                                     </td>
                                     <td class="col-property-bath">
                                         <span v-if="item.bath">
                                             {{ item.bath}}
                                         </span>
                                         <span v-else>—</span>
                                     </td>
                                     <td class="col-property-sqft">
                                        <span v-if="item.sqftTotal">{{ $filters.formatArea(item.sqftTotal, false)}} </span>
                                        <span v-else>—</span>
                                    </td>
                                     <td class="col-property-lotsize">
                                         <span v-if="item.lotSize">{{$filters.formatFriendlyLotSize(item.lotSize, item.lotSizeUnit)}}</span>
                                         <span v-else>—</span>
                                     </td>

                                     <td class="col-property-dom">
                                         <span data-allow-mismatch="text">
                                             {{item.createTimeDisplay}}
                                         </span>
                                     </td>
                                    <td>
                                        <button type="button" @click.stop="favoriteAction(item)" class="favorite" title="Save"><i class="icon-heart-o" :class="{'active': favoriteListings.indexOf(item.propertyId)>=0}"></i></button>
                                    </td>
                                 </tr>
                             </template>
                         </tbody>
                     </table>
                 </div>
                <div class="msp-banner-ad" v-if="isAdsBanner">
                    <mvtAds :options="{type:'banner', index:0}"></mvtAds>
                </div>
             </template>

             <template v-if="getTopListings && getTopListings.length">
                 <div>
                     <div class="panel">
                         <div class="h3">Latest Listings in {{getCityName}}</div>
                     </div>
                 </div>
                 <div
                     class="search-grid grid gap-2 grid-cols-1 sm-grid-cols-2"
                     :class="{ 'md-grid-cols-3 lg-grid-cols-4': msp.currentViewStatus !== 'map-view' }"
                 >
                     <mvtLazyload v-for="house in getTopListings">
                         <mvtCardProperty :cardFilter="getCardFilter"  v-if="house && house.propertyId"  :key="house.propertyId" :data="house" />
                     </mvtLazyload>
                 </div>
             </template>
             <searchError/>
        </div>
        <div v-if="geo.lat && geo.lng && msp.totalCount < msp.pageSize || (msp.firstPageIndex === msp.pageCount)" class="near-by-section">
            <button type="button" v-on:click="searchNearBy" class="btn secondary large">{{molang('search.common.seeNearBy')}}</button>
        </div>
        <searchFooter :key="msp.viewUrl" :restAds="getRestAds" :isAdsBanner="isAdsBanner" :isSplitView="msp.currentViewStatus === 'map-view' && msp.isSplitView"/>
    </div>
</template>

<script src="./search-list.js"></script>


<style lang="scss">
@use "./search-list.scss" as *;
</style>
